// extracted by mini-css-extract-plugin
module.exports = {"contentPlaceholder":"ContentPlaceholderExtension_contentPlaceholder__1qDZD"};